module.exports = __webpack_public_path__ + "img/sustainability.b3337a1.webp";